// Retorna a URL completa da imagem a partir do caminho fornecido pela API
export function getImageUrl(path) {
  if (!path) return '';
  // Remove barra inicial se houver para evitar duplicidade
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `https://api.dsiacdata.solutions/${cleanPath}`;
}
